import { useRollCompetitionEntriesValidate } from '@/api/roll-competition-entries';
import { useCreateRollCompetitionEntries } from '@/api/roll-competition-entries/mutations';
import { CommonModalsKey } from '@starsoft/common/enums';
import { useTransactionsNavigation } from '@starsoft/common/hooks';

import { useCallback } from 'react';

export function useRollPointSpinButton() {
  const { isPending, createRollCompetitionEntries } =
    useCreateRollCompetitionEntries();
  const useRollCompetitionEntriesValidateQuery =
    useRollCompetitionEntriesValidate();

  const { navigateToTransactionModal } = useTransactionsNavigation();

  const { canCreateRollCompetitionEntry } =
    useRollCompetitionEntriesValidateQuery;

  const spin = useCallback(() => {
    if (canCreateRollCompetitionEntry?.noDeposit) {
      navigateToTransactionModal(CommonModalsKey.Deposit);
      return;
    }
    createRollCompetitionEntries();
  }, [
    createRollCompetitionEntries,
    canCreateRollCompetitionEntry,
    navigateToTransactionModal,
  ]);

  return { spin, isPending, useRollCompetitionEntriesValidateQuery };
}
